import 'dual-listbox/dist/dual-listbox';

// 問題枠作成のリストボックス内容変更
export default () => {
  // selectタグ配下のoptionを作成する
  const createOption = (text, value, isSelected) => {
    const option = document.createElement('option');
    option.text = text;
    option.value = value;
    if (isSelected) option.setAttribute('selected', 'selected');
    dualListBox.appendChild(option);
  };

  // selectタグ配下のoptionsを置き換える
  const replaceOptionsInSelect = (select, options, selectedIds) => {
    // selectタグ配下をすべて削除
    while (select.firstChild) select.removeChild(select.firstChild);

    // 選択済みoption作成(changeはスルーする)
    selectedIds.forEach(({ text, value }) => {
      createOption(text, value, true);
    });

    // optionタグを挿入(選択済みは除く)
    const ids = selectedIds.map((item) => item.value);
    options
      .filter((option) => !ids.includes(option.value))
      .forEach(({ text, value }) => {
        createOption(text, value, false);
      });
  };

  // DualListboxを構築
  const createDualListbox = (options, selectedIds = [], ids = []) => {
    // MEMO:
    // constructorでoptionsを動的に指定するとソートが動かないので
    // selectタグを探して予めoptionsを置き換えておく
    const select = document.querySelector('select.dual-listbox');
    replaceOptionsInSelect(select, options, selectedIds, ids);
    const selectedList = document.getElementsByClassName('dual-listbox__selected');
    const countField = document.getElementById('practice_exam_exam_count');

    new DualListbox(select, {
      availableTitle: '問題マスター',
      selectedTitle: '選択済み問題',
      searchPlaceholder: '検索',

      addButtonText: '>',
      removeButtonText: '<',
      addAllButtonText: '>>',
      removeAllButtonText: '<<',

      sortable: true,
      upButtonText: '∧',
      downButtonText: '∨',

      addEvent: function (value) {
        countField.value = `${selectedList[0].childElementCount + 1}件選択中です`;
      },
      removeEvent: function (value) {
        countField.value = `${selectedList[0].childElementCount - 1}件選択中です`;
      },
    });
  };

  // 問題のリストを作る
  const dualListBox = document.querySelector('select.dual-listbox');
  if (!dualListBox) return;

  const dataset = dualListBox.dataset;
  const [firstList, secondList, selectedIds] = [
    dataset.first,
    dataset.second,
    dataset.selected,
  ].map((optionsJson) => {
    if (!optionsJson) return; // 新規作成時はnil

    const options = JSON.parse(optionsJson);
    return options.map((option) => ({
      text: `[管理番号: ${option[3]}] ${option[2]}`,
      value: option[1],
    }));
  });

  // 段階の切り替え用SelectBoxを取得
  const selectBox = document.getElementById('practice_exam_stage');
  if (!selectBox) return;

  // DualListboxを構築
  const switchList = (selectBox) => (selectBox.value === 'first' ? firstList : secondList);
  createDualListbox(switchList(selectBox), selectedIds);
  const selectedList = document.getElementsByClassName('dual-listbox__selected');
  const countField = document.getElementById('practice_exam_exam_count');
  countField.value = `${selectedList[0].childElementCount}件選択中です`;

  // 段階が選択されたとき
  selectBox.addEventListener('change', (event) => {
    // DualListboxを再構築
    document.querySelector('div.dual-listbox').remove();
    createDualListbox(switchList(event.target));
    countField.value = `${selectedList[0].childElementCount}件選択中です`;
  });
};
